import { range } from 'lodash';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  overflow: hidden;
  width: 100%;
`;

export const HorizontalProductCardSkeleton = ({ width = 360, height = 60 }) => {
  return (
    <StyledContentLoader viewBox={`0 0 ${width} ${height}`} width={width} height={height}>
      <rect x="2%" y="0" rx="0" ry="0" width="15%" height="60%" />
      <rect x="20%" y="0" rx="2" ry="2" width="20%" height="12%" />
      <rect x="20%" y="16%" rx="2" ry="2" width="30%" height="10%" />
      <rect x="20%" y="36%" rx="2" ry="2" width="70%" height="12%" />
      <rect x="20%" y="52%" rx="2" ry="2" width="50%" height="12%" />
      <rect x="20%" y="75%" rx="2" ry="2" width="15%" height="16%" />
    </StyledContentLoader>
  );
};

export const HorizontalProductCardsSkeletons = ({ count = 12, width, height }) => {
  const memorizedRange = useMemo(() => {
    return range(count).map(item => (
      <HorizontalProductCardSkeleton
        width={width}
        height={height}
        key={`horizontal-product-card-skeleton-${item}-${width}-${height}`}
      />
    ));
  }, [count, width, height]);

  return memorizedRange;
};

HorizontalProductCardSkeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

HorizontalProductCardsSkeletons.propTypes = {
  count: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
